const isEmpty = (val) =>
  val === null || val === undefined || val === "" ||
  (Array.isArray(val) && !val.length) ||
  (typeof val === "object" && !Array.isArray(val) && !Object.keys(val).length);

const label = (k) => k.replace(/_/g, " ");
const HIDDEN = new Set(["id", "status", "review", "created_at", "updated_at", "_id", "participant_invitation"]);

const fmt = (val) => (Array.isArray(val) ? val.join(", ") : typeof val === "boolean" ? (val ? "Yes" : "No") : String(val));

const Entry = ({ k, val }) => (
  <div>
    <dt className="font-mono text-[10px] uppercase tracking-widest text-silver/50">{label(k)}</dt>
    <dd className="font-body text-sm font-semibold break-words text-cream">{fmt(val)}</dd>
  </div>
);

// Non-recursive: renders top-level fields, then one nested level for section dicts.
export const DataBlock = ({ data }) => {
  const flat = [];
  const nested = [];
  Object.entries(data).forEach(([k, val]) => {
    if (HIDDEN.has(k) || isEmpty(val)) return;
    if (typeof val === "object" && !Array.isArray(val)) nested.push([k, val]);
    else flat.push([k, val]);
  });
  return (
    <div>
      <dl className="grid gap-x-6 gap-y-2 sm:grid-cols-2">
        {flat.map(([k, val]) => (
          <Entry key={k} k={k} val={val} />
        ))}
      </dl>
      {nested.map(([sec, obj]) => (
        <div key={sec} className="mt-3 border-t border-gold/15 pt-2">
          <p className="font-head text-xs font-extrabold uppercase tracking-widest text-goldlight">{label(sec)}</p>
          <dl className="mt-1 grid gap-x-6 gap-y-2 sm:grid-cols-2">
            {Object.entries(obj).map(([k, val]) =>
              isEmpty(val) ? null : <Entry key={k} k={k} val={typeof val === "object" && !Array.isArray(val) ? JSON.stringify(val) : val} />
            )}
          </dl>
        </div>
      ))}
    </div>
  );
};
